export default "__VITE_ASSET__06b40c96__"